<template>
    <div class="row">
        <div class="col-12 ">
            <div class="card mb-3" :class="{ 'cursor-pointer': isExporting, 'bg-primary-lighter text-white': isSelectedForExport }" @click="toggleExportMarking" v-if="!isFutureEvent || isExporting">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body text-elev-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" :class="{'text-white': isSelectedForExport }" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                <path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <p class="text-2xl mb-0"><strong>{{ lesson.relative_date_time_from }}</strong></p>
                        </div>
                        <div class="hr-wrapper">
                            <hr>
                        </div>
                        <div class="card-body pt-0">
                            <div class="row">
                                <div class="col-lg-6">
                                    {{ lesson.product_name }} <span v-if="lesson.class_short_name">({{ lesson.class_short_name }})</span>
                                    <br>
                                    <span v-if="lesson.teacher_name">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon-xs mb-1" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                                        </svg>
                                        {{ lesson.teacher_name }}
                                    </span>

                                    <span v-if="lesson.total_days > 1">
                                        <br>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon-xs mb-1" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
                                        </svg>
                                        {{ $t('Dag {number}', { number: lesson.day_number}) }}
                                    </span>
                                </div>
                                <div class="col-lg-6">
                                    <span v-if="lesson.elements.length">
                                        <strong>{{ $t('Opplæring') }}:</strong>
                                    </span>
                                    <ul class="square-list">
                                        <TcElement v-for="(element, i) in lesson.elements" :key="element.id" :element="element" :lesson="lesson" :class="{'text-success': element.is_approved && !isSelectedForExport}">
                                        </TcElement>
                                    </ul>
                                    <div v-if="showDetailedTeachingCard">
                                        <p v-if="lesson.tc_date_comment" class="mb-1"><strong>{{ $t('Kommentar på opplæringen') }}:</strong></p>
                                        <p :class="{ 'blockquote': lesson.tc_date_comment, 'text-white': isSelectedForExport }">
                                            <Nl2br tag="span" :text="lesson.tc_date_comment"/>
                                        </p>

                                        <p v-if="lesson.messages.length > 0" class="mb-1"><strong>{{ lesson.messages.length > 1 ? $t('Meldinger fra trafikklærer') : $t('Melding fra trafikklærer') }} :</strong></p>
                                        <p v-for="message in lesson.messages" class="blockquote">
                                            <Nl2br tag="span" :text="message.message"/> <br><small>{{ message.sender_name }} {{ $t('Sendt') }}: {{ message.sent_date }}</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import State from '../../state/teachingCardStore';
import TcElement from './TcElement';
import Nl2br from 'vue3-nl2br';

const props = defineProps(['lesson']);

const isExporting = computed(() => State.isExporting());
const isSelectedForExport = computed(() => State.isSelectedForExport(props.lesson.calendar_id));
const showDetailedTeachingCard = computed(() => State.displayDetailed());
const isFutureEvent = computed(() => State.isFutureEvent(props.lesson.calendar_id));

function toggleExportMarking() {
    if (isExporting.value) {
        State.toggleExportLesson(props.lesson.calendar_id);
    }
}
</script>